// 🧾 Installateurs — Phase 1 (F1) : module de calcul hebdomadaire STRICTEMENT équivalent au service backend
// `services/lmds_calcul_semaine.py` (référence = valeurs persistées). Testé par Jest contre les mêmes goldens
// (`src/__tests__/golden/lmds_calcul_goldens.json`). Taux de taxes : une seule source côté frontend = ce module.
export const TPS_RATE = 0.05;
export const TVQ_RATE = 0.09975;
// Taux installateur par défaut : paramètre backend `taux_installateur_defaut` (toujours servi par l'API via lmds_taux/taux) — plus de constante ici.

const f = (v) => parseFloat(v) || 0;
// Arrondi aligné sur Python round(x, 2) : `toFixed` travaille sur la valeur binaire exacte (16.575 → 16.57 comme Python).
// Égalité binaire EXACTE (x.125, x.375, x.625, x.875 — seuls milièmes dyadiques) : Python arrondit au pair, `toFixed` au
// supérieur → on reproduit le « half-even » (ex. 70.625 → 70.62, comme le backend).
const r2 = (v) => {
  const m = Math.round(v * 1000);
  if (m / 1000 === v && Math.abs(m) % 125 === 0 && Math.abs(m) % 250 !== 0) {
    const c = Math.floor(Math.abs(v) * 100);
    const pair = c % 2 === 0 ? c : c + 1;
    return Math.sign(v) * pair / 100 || 0;
  }
  const n = Number(v.toFixed(2));
  return Object.is(n, -0) ? 0 : n;
};

export function calculerLigne(ligne, taux) {
  const sc = f(ligne.service_call), km = f(ligne.km_montant), tip = f(ligne.tip_extra_cash), k = f(ligne.total);
  const estPaye = !!(ligne.est_delegation && ligne.sc_paye_cette_semaine && (sc > 0 || km > 0));
  let L, J;
  if (estPaye) {
    if (sc > 0) { L = (k + sc) * taux; J = km * taux; } else { L = (k + km) * taux; J = 0; }
  } else { J = (sc + km + tip) * taux; L = k * taux; }
  const M = L * TPS_RATE, N = L * TVQ_RATE;
  return { ...ligne, total_extra_installateur: r2(J), total_installateur: r2(L), tps: r2(M), tvq: r2(N), total_avec_taxes: r2(L + M + N), _L: L, _estPaye: estPaye };
}

export function calculerSemaine(rapport, taux) {
  let tSc = 0, tKm = 0, tTip = 0, tDed = 0, tK = 0, tL = 0;
  const lignes = (rapport.lignes || []).map((l) => calculerLigne(l, taux));
  for (const l of lignes) {
    const { _L: L, _estPaye: estPaye } = l;
    delete l._L; delete l._estPaye;
    const sc = f(l.service_call), km = f(l.km_montant), tip = f(l.tip_extra_cash), ded = f(l.deductions), k = f(l.total);
    if (l.delegue_a_id) continue;
    if (estPaye) { if (sc > 0) { tKm += km; tK += k + sc; } else { tK += k + km; } }
    else { tSc += sc; tKm += km; tK += k; }
    tTip += tip; tDed += ded; tL += L;
  }
  const auto = f(rapport.total_deductions_auto); // Phase 2 : déductions automatiques appliquées (HT) ; absent → 0
  const net = tL - tDed - auto;
  return {
    ...rapport, lignes,
    total_service_calls: r2(tSc), total_km: r2(tKm), total_tip: r2(tTip), total_deductions: r2(tDed), total_deductions_auto: r2(auto), total_contrats: r2(tK),
    total_extra_installateur: r2((tSc + tKm + tTip) * taux), total_installateur_brut: r2(tL), total_installateur_net: r2(net),
    tps_total: r2(net * TPS_RATE), tvq_total: r2(net * TVQ_RATE), total_avec_taxes: r2(net * (1 + TPS_RATE + TVQ_RATE)),
  };
}

export function resumeSemaine(rapport, taux) {
  const r = calculerSemaine(rapport, taux);
  return { ca_brut: r.total_contrats, part_installateur: r.total_installateur_brut, deductions_total: r.total_deductions, deductions_auto_total: r.total_deductions_auto,
    sous_total: r.total_installateur_net, tps: r.tps_total, tvq: r.tvq_total, total_avec_taxes: r.total_avec_taxes };
}
